<app-dashboard-layout>
  <section class="">
    <app-time-table></app-time-table>
  </section>
</app-dashboard-layout>
